import type { BoardLane, WorkItemCard } from '@zerohuman/shared'
import type { RunStatusTone } from '@/lib/statusTone'

/** The `/executions` board's lanes as the page names them. */
export const LANE_LABELS: Record<BoardLane, string> = {
    backlog: 'Backlog',
    ready: 'Ready',
    blocked: 'Blocked',
    inProgress: 'In Progress',
    complete: 'Complete',
}

// BG §18.4: a lane borrows the colour of the state it holds; Backlog and Ready are parked work, so they take neutral.
export const LANE_TONES: Record<BoardLane, RunStatusTone> = {
    backlog: 'neutral',
    ready: 'neutral',
    blocked: 'failed',
    inProgress: 'running',
    complete: 'completed',
}

export const PRIORITY_LABELS: Record<NonNullable<WorkItemCard['priority']>, string> = {
    urgent: 'Urgent',
    high: 'High',
    medium: 'Medium',
    low: 'Low',
}
